// import { Link } from "react-router-dom";
// import {
//   FiMapPin,
//   FiMail,
//   FiArrowRight,
//   FiLinkedin,
//   FiFacebook,
//   FiTwitter,
//   FiInstagram,
// } from "react-icons/fi";

// export default function Footer() {
//   return (
//     <footer className="bg-gradient-to-br from-blue-900 via-gray-900 to-blue-950 text-white pt-14 pb-6 font-sans tracking-tight">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
//           {/* Brand and Social */}
//           <div>
//             <h3 className="text-2xl font-black mb-4 font-[Inter] tracking-tight text-yellow-400">
//               Augere Strategies
//             </h3>
//             <p className="text-blue-200 mb-6 leading-relaxed text-base font-medium">
//               Transforming global businesses with expert telemarketing, Customer
//               support, and data-driven lead generation.
//             </p>
//             <div className="flex space-x-4 mt-7">
//               {/* Each social icon gets a circular, glowing background, scaling + color/blur on hover */}
//               <a href="#" aria-label="LinkedIn" className="group">
//                 <span
//                   className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-blue-600 to-blue-300/70
//                   shadow-lg group-hover:from-yellow-400 group-hover:to-yellow-300 group-hover:shadow-yellow-300/40
//                   group-hover:shadow-2xl hover:scale-110 transition-all duration-200"
//                 >
//                   <FiLinkedin
//                     size={24}
//                     className="text-blue-100 group-hover:text-blue-900 transition"
//                   />
//                 </span>
//               </a>
//               <a href="#" aria-label="Facebook" className="group">
//                 {/* <span
//                   className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-blue-500 to-blue-400/70
//                   shadow-lg group-hover:from-yellow-400 group-hover:to-yellow-300 group-hover:shadow-yellow-200/30
//                   hover:scale-110 group-hover:shadow-2xl transition-all duration-200"
//                 >
//                   <FiFacebook
//                     size={24}
//                     className="text-blue-100 group-hover:text-blue-900 transition"
//                   />
//                 </span> */}
//               </a>
//               <a href="#" aria-label="Twitter" className="group">
//                 <span
//                   className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-cyan-500 to-blue-200/80
//                   shadow-lg group-hover:from-yellow-400 group-hover:to-yellow-200 group-hover:shadow-yellow-200/30
//                   hover:scale-110 group-hover:shadow-2xl transition-all duration-200"
//                 >
//                   <FiTwitter
//                     size={24}
//                     className="text-blue-100 group-hover:text-blue-900 transition"
//                   />
//                 </span>
//               </a>
//               {/* <a href="#" aria-label="Instagram" className="group">
//                 <span
//                   className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-pink-400 to-yellow-300/40
//                   shadow-lg group-hover:from-yellow-400 group-hover:to-pink-300 group-hover:shadow-yellow-200/30
//                   hover:scale-110 group-hover:shadow-2xl transition-all duration-200"
//                 >
//                   <FiInstagram
//                     size={24}
//                     className="text-blue-100 group-hover:text-blue-900 transition"
//                   />
//                 </span>
//               </a> */}
//             </div>
//           </div>
//           {/* Quick Links */}
//           <div>
//             <h4 className="text-lg font-extrabold mb-4 tracking-wide text-yellow-300">
//               Quick Links
//             </h4>
//             <ul className="space-y-2 text-[17px]">
//               <li>
//                 <Link
//                   to="/"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Home <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   About Us <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Services <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/career"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Career <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Contact Us <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//             </ul>
//           </div>
//           {/* Services */}
//           <div>
//             <h4 className="text-lg font-extrabold mb-4 tracking-wide text-yellow-300">
//               Our Services
//             </h4>
//             <ul className="space-y-2 text-[17px]">
//               <li>
//                 <Link
//                   to="/dataBuildservices"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Data Build <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/mortgageservices"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   US Mortgage Underwriting
//                   <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/customersupportservices"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Customer Support Services <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/Webinarregistrationservices"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Webinar Registration Services{" "}
//                   <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//               <li>
//                 {/* <Link
//                   to="/telecallingservices"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Telecalling Services <FiArrowRight className="ml-1" />
//                 </Link> */}
//               </li>
//               <li>
//                 <Link
//                   to="/leadgenration"
//                   className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
//                 >
//                   Lead Generation <FiArrowRight className="ml-1" />
//                 </Link>
//               </li>
//             </ul>
//           </div>
//           {/* Contact */}
//           <div>
//             <h4 className="text-lg font-extrabold mb-4 tracking-wide text-yellow-300">
//               Contact
//             </h4>
//             <ul className="space-y-2 text-blue-200 text-base">
//               <li className="flex items-start gap-2">
//                 <FiMapPin className="mt-1 text-yellow-400" />
//                 2A43 Nalanda Complex, Evershine Nagar Malad West, Mumbai -
//                 400064 Maharashtra, India
//               </li>
//               {/* Phone number removed */}
//               <li className="flex items-center gap-2">
//                 <FiMail className="text-yellow-400" />
//                 <a
//                   href="mailto:info@augereconversion.com"
//                   className="hover:text-yellow-400 transition"
//                 >
//                   For Email click here
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//         <div className="border-t border-blue-900 mt-10 pt-8 text-center text-blue-300 text-sm tracking-wide">
//           <p>
//             © {new Date().getFullYear()} Augere Strategies . All rights
//             reserved.
//           </p>
//           <p>
//             powered by{" "}
//             <a
//               href="https://kesaritechnology.com/"
//               target="_blank"
//               rel="noreferrer"
//             >
//               Kesari Technology
//             </a>
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// }

import {
  FiMapPin,
  FiMail,
  FiArrowRight,
  FiLinkedin,
  FiFacebook,
  FiTwitter,
  FiInstagram,
} from "react-icons/fi";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-900 via-gray-900 to-blue-950 text-white pt-14 pb-6 font-sans tracking-tight">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
          {/* Brand and Social */}
          <div>
            <h3 className="text-2xl font-black mb-4 font-[Inter] tracking-tight text-yellow-400">
              Augere Strategies
            </h3>
            <p className="text-blue-200 mb-6 leading-relaxed text-base font-medium">
              Transforming global businesses with expert telemarketing, Customer
              support, and data-driven lead generation.
            </p>
            <div className="flex space-x-4 mt-7">
              <a href="#" aria-label="LinkedIn" className="group">
                <span
                  className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-blue-600 to-blue-300/70 
                  shadow-lg group-hover:from-yellow-400 group-hover:to-yellow-300 group-hover:shadow-yellow-300/40
                  group-hover:shadow-2xl hover:scale-110 transition-all duration-200"
                >
                  <FiLinkedin
                    size={24}
                    className="text-blue-100 group-hover:text-blue-900 transition"
                  />
                </span>
              </a>

              <a href="#" aria-label="Facebook" className="group">
                {/* Uncomment if needed */}
                {/* <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-blue-500 to-blue-400/70 shadow-lg group-hover:from-yellow-400 group-hover:to-yellow-300 group-hover:shadow-yellow-200/30 hover:scale-110 group-hover:shadow-2xl transition-all duration-200">
                  <FiFacebook size={24} className="text-blue-100 group-hover:text-blue-900 transition" />
                </span> */}
              </a>

              <a href="#" aria-label="Twitter" className="group">
                <span
                  className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-cyan-500 to-blue-200/80 
                  shadow-lg group-hover:from-yellow-400 group-hover:to-yellow-200 group-hover:shadow-yellow-200/30
                  hover:scale-110 group-hover:shadow-2xl transition-all duration-200"
                >
                  <FiTwitter
                    size={24}
                    className="text-blue-100 group-hover:text-blue-900 transition"
                  />
                </span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-extrabold mb-4 tracking-wide text-yellow-300">
              Quick Links
            </h4>
            <ul className="space-y-2 text-[17px]">
              <li>
                <a
                  href="/"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Home <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  About Us <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Services <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/career"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Career <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Contact Us <FiArrowRight className="ml-1" />
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-extrabold mb-4 tracking-wide text-yellow-300">
              Our Services
            </h4>
            <ul className="space-y-2 text-[17px]">
              <li>
                <a
                  href="/dataBuildservices"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Data Build <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/mortgageservices"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  US Mortgage Underwriting <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/customersupportservices"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Customer Support Services <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="/Webinarregistrationservices"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Webinar Registration Services{" "}
                  <FiArrowRight className="ml-1" />
                </a>
              </li>
              <li>
                {/* Uncomment if needed */}
                {/* <a
                  href="/telecallingservices"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Telecalling Services <FiArrowRight className="ml-1" />
                </a> */}
              </li>
              <li>
                <a
                  href="/leadgenration"
                  className="flex items-center text-blue-200 hover:text-yellow-400 transition font-medium"
                >
                  Lead Generation <FiArrowRight className="ml-1" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-extrabold mb-4 tracking-wide text-yellow-300">
              Contact
            </h4>
            <ul className="space-y-2 text-blue-200 text-base">
              <li className="flex items-start gap-2">
                <FiMapPin className="mt-1 text-yellow-400" />
                2A43 Nalanda Complex, Evershine Nagar Malad West, Mumbai -
                400064 Maharashtra, India
              </li>
              <li className="flex items-center gap-2">
                <FiMail className="text-yellow-400" />
                <a href="/contact" className="hover:text-yellow-400 transition">
                  For Email click here
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-blue-900 mt-10 pt-8 text-center text-blue-300 text-sm tracking-wide">
          <p>
            © {new Date().getFullYear()} Augere Strategies . All rights
            reserved.
          </p>
          <p>
            powered by{" "}
            <a
              href="https://kesaritechnology.com/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-yellow-400 transition"
            >
              Kesari Technology
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
